// the M3D_SCENES_BASE_URL is an amazon S3 bucket distributed over cloudfront
export const M3D_SCENES_BASE_URL = 'unity/';
// export const M3D_SCENES_BASE_URL = 'https://scenes.3dmeet.com/';

export const COMMAND_ROUTE = 'c';
export const USER_ROUTE = 'u';
export const VIEWBOARD_SYNC = 'b';
